import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const vehiclesSlice = createSlice({
    name: 'vehicles',
    initialState,
    reducers: {
        setVehicles(state, action) {
            return action.payload;
        },
        addVehicle(state, action) {
            state.push(action.payload);
        },
        removeVehicles(state) {
            return initialState;
        },
    },
});

export const { setVehicles, addVehicle, removeVehicles } = vehiclesSlice.actions;
export default vehiclesSlice.reducer;